import { Type } from '@angular/core';
import { Route } from '@angular/router';
import { UrlSegment } from '@app/shared/types/enums/url-segment.enum';
import { DraftProjectsComponent } from '@app/views/company/draft-projects/draft-projects.component';
import { EditProjectViewComponent } from '@app/views/company/projects/edit-project/edit-project-view.component';

export const ROUTING_COMPONENTS: Type<unknown>[] = [DraftProjectsComponent];

export const draftProjectsRoutes: Route[] = [
  {
    path: '',
    component: DraftProjectsComponent,
    children: [
      {
        path: ':draft-project-id',
        children: [
          {
            path: UrlSegment.EDIT,
            component: EditProjectViewComponent
          }
        ]
      }
    ]
  }
];
